import React from 'react'

function Header() {
    const headerStyle ={
        "text-align": "center",
    }
    return (
        <div>
            <h1 style={headerStyle}>Meme Generator</h1>
        </div>
    )
}

export default Header
